(function fileDefinition() {
    'use strict';
    angular.module('Entities')
        .service('fileService', [
            'restUrlBuilder', 'Upload', 'config', '$q',
            function fileService(restUrlBuilder, $upload, config, $q) {
                this.getById = function getById(id) {
                    var params = { OriginalType: false };

                    return restUrlBuilder.one('files', id)
                        .get({ params: params });
                };


                this.SignDocument = function SignDocument(fileId, urlCallback) {
                    var params = { urlRedirect: config.appUrl(urlCallback) };
                    
                    return restUrlBuilder.one('filesGob/SignNacion', fileId)
                        .get({ params: params });
                };

                this.getDocumentVersion = function getDocumentVersion(id, version, viewAll, fileId) {
                    var params = { id: id, version: version, viewAll: viewAll, fileId : fileId };

                    return restUrlBuilder.all('files')
                        .get({ params: params });

                };

                this.shareInline = function shareInline(base64file) {
                    var parameter = { Base64File: base64file }
                    return restUrlBuilder.all('files/share').post(parameter);
                };


                this.getDocumenContainer = function getDocumenContainer(id) {
                    return restUrlBuilder.one('files/GetContainerFiles', id)
                        .get();
                };

                this.getSignatures = function getSignatures(id) {
                    return restUrlBuilder.one('files/GetSignatures', id).get();
                }

                this.download = function download(id) {
                    return restUrlBuilder.one('files/Download', id).get();
                };

                this.validateHash = function validateHash(id) {
                   return restUrlBuilder.one('files/ValidateHash', id).get();
                };

                this.askOcr = function askOcr(id) {
                    return restUrlBuilder.one('files/AskOcr', id).get();
                };

                this.downloadFilesDocument = function downloadFilesDocument(documentId, temporalVersion) {
                    var params = { id: documentId, TempVersion: temporalVersion };

                    return restUrlBuilder.all('files/Download').get({ params: params });
                };

                this.masiveDownloadFilesDocument = function masiveDownloadFilesDocument(documentIds) {
                    
                    return restUrlBuilder.all('files/MassiveDownload').put(documentIds);
                };

                this.downloadFilesContainer = function downloadFilesContainer(containerId) {
                    return restUrlBuilder.one('files/DownloadContainer', containerId).get();
                };

                this.FormatfileSize = function FormatfileSize(bytes, precision) {
                    if (bytes == 0 || isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '0';
                    if (typeof precision === 'undefined') precision = 0;
                    var units = ['b', 'KB', 'MB', 'GB', 'TB', 'PB'],
                        number = Math.floor(Math.log(bytes) / Math.log(1024));
                    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
                };

                this.base64ToBlob = function base64ToBlob(data, type) {
                    if (data) {
                        var raw = atob(data);
                        var uint8Array = new Uint8Array(raw.length);
                        for (var i = 0; i < raw.length; i++) {
                            uint8Array[i] = raw.charCodeAt(i);
                        }
                        return new Blob([uint8Array.buffer], { type: type });
                    }
                    return null;
                }

                var that = this;

                this.preview = function (file, base64UrlOrFile) {

                    // si files es un objeto y no un File entonces no envío el archivo.
                    if (!angular.isUndefined(file.stream) && file.id) {
                        var deferred = $q.defer();

                        restUrlBuilder.all('files/PdfConverter')
                                      .post([file])
                                      .then(function (result) {
                                          if (base64UrlOrFile) {
                                              deferred.resolve('data:application/pdf;base64,' + result.value.base64File);
                                          } else {
                                              deferred.resolve(that.base64ToBlob(result.value.base64File, 'application/pdf'));
                                          }
                                      },
                                      function () {
                                          deferred.reject.apply(this, arguments);
                                      });

                        return deferred.promise;

                    } else {
                        // si ya es un pdf entonces no lo convierto
                        if (file.name.indexOf(".pdf") === file.name.length - 4) {
                            return $q.when(file);    // es un File object.
                        } else {
                            var deferred = $q.defer();

                            $upload.upload({
                                url: config.apiUrl('/files/PdfConverter'),
                                method: 'POST',
                                fields: {},
                                file: file,
                                fileFormDataName: 'previewFile'
                            }).then(function (result) {
                                if (base64UrlOrFile) {
                                    deferred.resolve('data:application/pdf;base64,' + result.data);
                                } else {
                                    deferred.resolve(that.base64ToBlob(result.data, 'application/pdf'));
                                }
                            },
                            function () {
                                deferred.reject.apply(this, arguments);
                            });

                            return deferred.promise;
                        }
                    }

                };

                this.readBarCode = function (configBc, file) {
                    
                    // si files es un objeto y no un File entonces no envío el archivo.
                    //var deferred = $q.defer();
                    
                    return $upload.upload({
                        url: config.apiUrl('/files/ReadBarCode','bc'),
                        method: 'POST',
                        fields: { configBc: JSON.stringify(configBc) },
                        file: file,
                        fileFormDataName: 'imageFile'
                    });
                }
            }
        ]);
})();